{
    "common": {
        "mon": "Pon",
        "tue": "Uto",
        "wed": "Sri",
        "thu": "Čet",
        "fri": "Pet",
        "sat": "Sub",
        "sun": "Ned",
        "jan": "Sij",
        "feb": "Velj",
        "mar": "Ožu",
        "apr": "Tra",
        "jun": "Lip",
        "jul": "Srp",
        "aug": "Kol",
        "sep": "Ruj",
        "oct": "Lis",
        "nov": "Stu",
        "dec": "Pro",
        "january": "Siječanj",
        "february": "Veljača",
        "march": "Ožujak",
        "april": "Travanj",
        "may": "Svibanj",
        "june": "Lipanj",
        "july": "Srpanj",
        "august": "Kolovoz",
        "september": "Rujan",
        "october": "Listopad",
        "november": "Studeni",
        "december": "Prosinac",
        "checkin": "Prijava",
        "checkout": "Odjava",
        "room": "Soba",
        "rooms": "Sobe",
        "adult": "Odrasli",
        "adults": "Odrasli",
        "edit": "Uredi",
        "editCap": "UREDI",
        "delete": "Obriši",
        "deleteCap": "OBRIŠI",
        "localTime": "Lokalno Vrijeme",
        "back": "NAZAD",
        "home": "POČETNA",
        "yes": "DA",
        "no": "NE",
        "left": "Preostalo",
        "hour": "Sat",
        "hours": "Sata",
        "night": "noć",
        "nights": "noći",
        "for": "za",
        "why": "Zašto",
        "get": "Nabavite",
        "more": "Više",
        "agree": "SLAŽEM SE",
        "disagree": "NE SLAŽEM SE",
        "basedOn": "na temelju",
        "error": "Došlo je do greške, pokušajte kasnije ponovno",
        "error2": "Neuspješno, pokušajte ponovno!",
        "error3": "Došlo je do Greške!!",
        "error4": "Došlo je do greške!! Molimo pokušajte ponovno",
        "error5": "Oprostite!! Došlo je do greške. Molimo pokušajte ponovno za nekoliko trenutaka.",
        "hi": "Bok",
        "to": "za",
        "free": "Besplatno",
        "per": "Po",
        "at": "u",
        "day": "Dan",
        "days": "Dana",
        "time": "Vrijeme",
        "of": "od",
        "photo": "Fotografija",
        "photos": "Fotografije",
        "done": "Gotovo",
        "fullStay": "Cijeli Boravak",
        "date": "Datum",
        "and": "i",
        "bookingDetail": "Detalji Rezervacije",
        "Back": "Nazad",
        "Home": "Početna"
    },
    "userPopup": {
        "myAccount": "Moj Račun",
        "welcome": "Dobrodošli",
        "user": "Korisnik",
        "findMyBookings": "PRONAĐI MOJE REZERVACIJE",
        "viewProfile": "POGLEDAJ PROFIL",
        "makeAReservarion": "NAPRAVI REZERVACIJU",
        "logout": "ODJAVA",
        "loginCap": "PRIJAVA",
        "login": "Prijava",
        "invalidCredentials": "Nevažeće vjerodajnice",
        "invalidEmail": "Nevažeći Email",
        "passwordIsRequired": "Lozinka je obavezna",
        "minChar8": "minimalno 8 znakova",
        "tooShort": "Prekratko!",
        "tooLong": "Predugo!",
        "required": "Obavezno",
        "emailInvalid": "Unesite važeći email",
        "passwordInvalid": "Unesite važeću lozinku",
        "phNumInvalid": "Broj telefona nije važeći",
        "signupCap": "REGISTRIRAJ SE",
        "signup": "Registracija",
        "verifyText": "Potvrdite da ste to vi",
        "verifyText2": "Poslali smo verifikacijski kod na vašu email adresu",
        "verificationCode": "Verifikacijski Kod",
        "didNotReceiveEmail": "Nije primljen email",
        "clickToResend": "Kliknite za ponovno slanje",
        "verifyAndSignIn": "Verificiraj i prijavi se",
        "otpSentSuccessfully": "Kod je uspješno poslan",
        "somethingWentWrong": "Nešto je pošlo po zlu, pokušajte ponovno",
        "otpError": "Molimo unesite važeći broj",
        "otpError2": "Molimo unesite samo brojeve",
        "otpError3": "Netočan kod, molimo pokušajte ponovno",
        "otpError4": "Kod istekao, kliknite Pošalji ponovno da biste pokušali ponovno",
        "otpError5": "Molimo pokušajte ponovno",
        "forgetPassword": "Zaboravljena Lozinka",
        "submitError": "Korisnik ne postoji!",
        "userExistError": "Korisnik već postoji",
        "checkYourEmail": "Provjerite svoj email",
        "passwordResetLinkSent": "Poslali smo link za resetiranje lozinke na",
        "noWorriesResetInstructions": "Bez brige, poslat ćemo vam upute za resetiranje.",
        "enterYourEmail": "Unesite svoj email",
        "resetMyPassword": "RESETIRAJ MOJU LOZINKU",
        "setANewPassword": "Postavite novu lozinku",
        "newPassword": "Nova Lozinka",
        "confirmPassword": "Potvrdite Lozinku",
        "confirmPasswordError": "Lozinke moraju biti iste",
        "backToLogin": "Povratak na prijavu",
        "dontHaveAccount": "Nemate račun?",
        "alreadyHaveAccount": "Već imate račun?",
        "memberDiscount1": "Dobit ćete",
        "memberDiscount2": "članstvo popust zauvijek.",
        "discount1": "Upravljajte svim svojim rezervacijama s jednog mjesta.",
        "discount2": "Registrirajte se za personalizirane preporuke i prilagođena iskustva!!",
        "discount3": "Pridružite se našoj zajednici sretnih gostiju i počnite planirati svoj boravak.",
        "leftGridText1": "Upravljajte svim svojim rezervacijama s jednog mjesta",
        "leftGridText2": "Registrirajte se za personalizirane preporuke i prilagođena iskustva!!",
        "leftGridText3": "Pridružite se našoj zajednici sretnih gostiju i počnite planirati svoj boravak",
        "gridDiscountText1": "članstvo popust na",
        "gridDiscountText2": "odabranim gostionicama zauvijek",
        "gridDiscountText3": "Prijavite se za prilagođeno iskustvo zauvijek",
        "gridDiscountText4": "Nabavite Ekskluzivne Prednosti Članstva",
        "findBookingError": "Vaš email i rezervacijski id se ne poklapaju",
        "verifyAndConfirmBooking": "Verificirajte i potvrdite rezervaciju",
        "confirmEmailText": "Poslali smo verifikacijski kod na vašu email adresu",
        "enterCodeText": "Molimo unesite verifikacijski kod koji vam je poslan",
        "didNotRecieveEmail": "Nije primljen email?",
        "changeEmailText": "Kliknite ovdje da biste promijenili email adresu",
        "verifyAndConfirm": "Verificirajte i Potvrdite",
        "verified": "VERIFICIRANO",
        "bookingExpired": "Rezervacija Isteče",
        "bookingExpiredText": "Žao nam je, rezervacijski id koji koristite je istekao",
        "backToFindingBooking": "Povratak na pronalazak rezervacije",
        "findMyBooking": "Pronađi Moje Rezervacije",
        "bookingEmail": "Email Rezervacije",
        "reservationId": "ID Rezervacije",
        "findBooking": "PRONAĐI REZERVACIJU",
        "abandonmentCartDoneText1": "Hvala vam!",
        "abandonmentCartDoneText2": "Detalji vaše košarice poslani su na email. Nastavite svoju rezervaciju u bilo kojem trenutku.",
        "Recommended Currencies": "Preporučene Valute",
        "All currencies": "Sve valute",
        "thisIsRequiredField": "Ovo je obvezno polje"
    },
    "widget": {
        "destination": "Odredište",
        "enterDestination": "UNESI ODREDIŠTE",
        "guests": "Gosti",
        "guest": "Gost",
        "nationality": "Državljanstvo",
        "selectNationality": "Odaberite državljanstvo",
        "nationalityIsRequired": "Državljanstvo je obavezno",
        "selectedRate": "Posebna cijena",
        "search": "Traži",
        "ages": "Dob",
        "orAbove": "Ili Više",
        "child": "Dijete",
        "children": "Djeca",
        "addAnotherRoom": "Dodaj Još Jednu Sobu",
        "removeRoom": "Ukloni Sobu",
        "property": "Gostionica",
        "city": "Grad",
        "country": "Zemlja",
        "bookNow": "Rezerviraj Sada",
        "overnightStay": "Noćenje",
        "dayUse": "Dnevna Uporaba",
        "destinationIsRequired": "Odredište je obavezno",
        "checkInIsRequired": "Datum početka je obavezan",
        "checkOutIsRequired": "Datum završetka je obavezan",
        "noLocationFound": "Lokacija Nije Pronađena",
        "soldOut": "Rasprodano",
        "highDemand": "Visoka Potražnja",
        "dates": "Datumi",
        "allRates": "Sve cijene su u",
        "K": "K",
        "M": "M",
        "sameDayCheckout": "Odjava isti dan"
    },
    "promotion": {
        "headingText": "Važne Informacije za",
        "regularRate": "Nijedno",
        "seniorCitizen": "Cijena za Starije",
        "agencyRate": "Cijena Agencije",
        "caaRate": "Cijena CAA/AAA",
        "corporateRate": "Korporativna Cijena",
        "governmentRate": "Vladina/Vojna Cijena",
        "promotionalSpecialRate": "Promotivna/Posebna Cijena",
        "regularRateDescription": "Nije primijenjena nijedna promocija.",
        "seniorCitizenRateDescription": "Ovo je snižena hotelska cijena koja je široko dostupna starijim odraslima, obično u dobi od 60 godina ili starijima.",
        "agencyRateDescription": "Ovo je snižena hotelska cijena koja se nudi i može pristupiti samo kroz određene putne agente samo potičući partnerstvo i suradnju.",
        "caaRateDescription": "Ovo je posebna hotelska cijena koja se nudi članovima AAA ili CAA za ekskluzivne uštede.",
        "corporateRateDescription": "Ovo je snižena hotelska cijena koja se proširuje na poslovne putnike, obično pregovarana između hotela i korporativnog entiteta.",
        "governmentRateDescription": "Ovaj plan cijena nudi specifične popuste za Vladino/Vojno osobno za rezervaciju hotelske sobe.",
        "contentSeniorCitizen": "Potvrda datuma rođenja je obavezna u vrijeme prijave. Nepredoširanje relevantnog osobnog osiguranja će rezultirati naplatom važećih cijena.",
        "contentAgencyRate": "Budite sigurni da imate potvrdu rezervacije i osiguranje osobnosti pri dolasku. Nepredstavak njih rezultirat će primjenom standardnih cijena.",
        "contentPromotionalSpecialRate": "Ovo je snižena hotelska cijena koja se nudi na ograničeno vrijeme, često povezana sa specifičnim događajima, sezonama ili marketinškim kampanjama.",
        "contentCaaRate": "Molimo osigurajte da imate člansku karticu CAA ili relevantnu identifikaciju u vrijeme prijave. Nepredoširanje relevantnog osobnog osiguranja će rezultirati naplatom važećih cijena.",
        "contentCorporateRate": "Dokaz korporativne osobne ili druge službene dokumentacije je potreban u vrijeme prijave. Nepredoširanje relevantnog dokaza će rezultirati naplatom važećih cijena.",
        "contentGovernmentRate": "Vrijedno vladinog ili vojnog osobnog osobnog osiguranja mora biti zadano pri prijavi. Nepredstavak potrebne identifikacije će rezultirati naplatom po standardnoj cijeni.",
        "CORP": "CORP",
        "AGEN": "AGEN",
        "PROM": "PROM",
        "apply": "PRIMIJENI",
        "Offer Code": "Kod Ponude",
        "Agency Code": "Kod Agencije",
        "Corporate Code": "Korporativni Kod",
        "All-Access Rate": "Cijena Pristupa",
        "errorCode": "Ovaj Kod nije važeći"
    }
}

